import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  AppButton,
  Box,
  List,
  RedesignNotFoundIcon,
  Responsive,
  Text,
  useResponsive,
} from '@common-fe/common-fe';

import { useTransactionsHistoryQuery } from '../InvestmentActivities/queries';
import { useInvestmentTabStore } from '../stores';
import { InvestmentsTab } from '../stores/useInvestmentTab.store';

import ActivityPreviewCard from './ActivityPreviewCard';
import InvestmentsListWrapper from './PreviewListWrapper';

const MIN_DISPLAYED_ITEMS = 5;
interface Props {}
const InvestmentsActivities: React.FC<Props> = () => {
  const setCurrentTab = useInvestmentTabStore((state) => state.setCurrentTab);
  const setHighlightedActivity = useInvestmentTabStore((state) => state.setHighlightedActivity);
  // const { data, isLoading } = useInvestmentActivitiesList({
  //   investor_id: details?.investorId ? _.toNumber(details?.investorId) : undefined,
  //   page: 0,
  //   size: 7,
  // });
  const { data, isLoading } = useTransactionsHistoryQuery({
    page: 0,
    perPage: 7,
    startDate: null,
    endDate: null,
    funds: [],
  });
  const { t } = useTranslation();

  const formattedList = useMemo(() => {
    return [...data].splice(0, MIN_DISPLAYED_ITEMS);
  }, [data]);

  const handleRedirect = useCallback(() => {
    window.scrollTo({ top: 0 });
    setCurrentTab(InvestmentsTab.Activity);
    setHighlightedActivity('activities');
  }, [setCurrentTab, setHighlightedActivity]);
  const handleRedirectWithId = useCallback(
    (id?: string) => () => {
      window.scrollTo({ top: 0 });
      setCurrentTab(InvestmentsTab.Activity);
      setHighlightedActivity(id);
    },
    [setCurrentTab, setHighlightedActivity]
  );
  const { isMobile } = useResponsive();
  return (
    <InvestmentsListWrapper
      leftChildren={
        <>
          <Text size={isMobile ? 'xxlarge' : '3xl'} weight={700}>
            {t('Activities')}
          </Text>
          <Responsive sizes={[Responsive.Desktop, Responsive.Tablet]}>
            {!!formattedList.length && (
              <Box margin={{ top: 's' }}>
                <AppButton testId="activities_preview" onClick={handleRedirect}>
                  {t('View Details')}
                </AppButton>
              </Box>
            )}
          </Responsive>
        </>
      }
    >
      <List>
        {!isLoading && !formattedList.length ? (
          <Box align="center" justify="center" direction="column">
            <RedesignNotFoundIcon color="iconDisabled" size="32px" />
            <Text weight={400} size="medium" margin={{ top: 'xs' }}>
              {t('There are no activities yet')}
            </Text>
          </Box>
        ) : (
          <>
            {isLoading && <List.Preloader testId="activities_preview_loader" count={5} />}
            {formattedList.map((item, index) => (
              <ActivityPreviewCard
                onClick={handleRedirectWithId(item.id)}
                index={index}
                key={item.id}
                {...item}
              />
            ))}
          </>
        )}
      </List>
      <Responsive size={Responsive.Mobile}>
        {!!formattedList.length && (
          <Box margin={{ top: 'spacing24' }}>
            <AppButton fill testId="activities_preview" onClick={handleRedirect}>
              {t('View Details')}
            </AppButton>
          </Box>
        )}
      </Responsive>
    </InvestmentsListWrapper>
  );
};

export default InvestmentsActivities;
